import { Datum } from '../../';


/**
 * A wrapper for an individual datum (usually part of a time series)
 */
export class DateDatum extends Datum {
  /**
   * Initialize a Datum pair from a date and value
   * 
   * @param {Date} date Javascript Date describing the data point date-time
   * @param {Number|Array} value Number (or number array) with measurement(s)
   */
  constructor(date, value) {
    if (!(date instanceof Date))
      throw Error('Date is not a valid date');
    if (!(value === null || typeof value === 'number' || Array.isArray(value)))
      throw Error('Value is not a number, null, or Array');

    super(date, value);
  }
}